fragment DiscountFragment on Discount {
    id
    type
    discount
    company
    group_id
    group {
        ...DiscountGroupFragment
    }
}